import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { Person, Sex } from '../types/form';
import { getFirstName, getLastName } from '../helpers/person';

interface FormPersonProps {
  person: Person;
  setPerson: (name: Person) => void;
}

function FormPerson({ person, setPerson }: FormPersonProps) {
  return (
    <Form.Group className="mb-3" controlId="formName">
      <Form.Label>Imię i nazwisko:</Form.Label>
      <InputGroup>
        <Form.Select value={person.sex || Sex.MALE} onChange={(event: any) => {
          setPerson({ firstName: person.firstName, lastName: person.lastName, sex: event.target.value });
        }}>
          <option value={Sex.MALE}>druh</option>
          <option value={Sex.FEMALE}>druhna</option>
        </Form.Select>
        <Form.Control type="text" value={person.firstName || ''} onChange={(event: any) => {
          setPerson({ firstName: event.target.value || null, lastName: person.lastName, sex: person.sex });
        }} placeholder={`np. ${getFirstName(person)}`} />
        <Form.Control type="text" value={person.lastName || ''} onChange={(event: any) => {
          setPerson({ firstName: person.firstName, lastName: event.target.value || null, sex: person.sex });
        }} placeholder={`np. ${getLastName(person)}`} />
      </InputGroup>
    </Form.Group>
  );
}

export default FormPerson;
